import SC from "./style";
import { useEffect, useState } from "react";
import { Button, Label, Loader } from "InnoUI/components";
import theme from "@theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { CompanyDropdown, CountryCodeDropdown, InputField } from "components";
import { FormControlLabel, Radio, RadioGroup, Switch } from "@mui/material";
import { genderOption, nameTitle, sendCedential } from "utils/optionData/utils";
import { apiPost } from "api/callApi";
import { regexTypes, validateEmail, validtionMessages } from "utils/config";
import { useSelector } from "react-redux";
import { showAlert } from "utils/helper";

function AddEditNewUser(props) {
  const {
    userdata,
    isEditing = true,
    setIsEditing,
    fetchData,
    companyId,
    setOpenModalView,
    openModalView,
    roleId,
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    gender: "2",
    title: "0",
    sendUserCredential: "0",
    telCode: "+27",
    cellCode: "+27",
    // faxCode: "+27",
    adminStatus: false,
    isGoogleSignIn: false,
    companyId: companyId,
  });
  const [errorKeys, setErrorKeys] = useState({
    userName: false,
    email: false,
    secondaryEmail: false,
  });

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );
  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || []
  );

  // Set initial data based on editing state
  useEffect(() => {
    if (isEditing) {
      const newData = { ...userdata };
      if (userdata?.userType === 2) {
        newData.adminStatus = false;
      } else {
        newData.adminStatus = true;
      }
      setData(newData);
    }
  }, [isEditing, userdata]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      ...data,
      userName: data.email,
    };

    if (!validateEmail(data.email)) {
      setErrorKeys((prevKeys) => ({ ...prevKeys, email: true }));
      return;
    }
    if (data.secondaryEmail && !validateEmail(data.secondaryEmail)) {
      setErrorKeys((prevKeys) => ({ ...prevKeys, secondaryEmail: true }));
      return;
    }
    setErrorKeys({
      email: false,
      secondaryEmail: false,
    });
    setLoading(true);
    try {
      const endpoint = isEditing
        ? `/v1/edituser/${userdata.id}`
        : `/v1/adduser`;
      const response = await apiPost(endpoint, formData);
      setLoading(false);
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      setData({});
      if (response.data) {
        const result = await apiPost(`/v1/occupant/contactinformation`, {
          userId: [response.data.id],
          projectId: currentProject.id,
          occupantId: currentOccupant.id,
          roleId: roleId,
        });
        showAlert({ title: "Success", text: result?.message, icon: "success" });
        setData({});
      }
      await fetchData();
      setOpenModalView(false);
    } catch (error) {
      console.error("Error:", error);
      showAlert({
        title: "error",
        text: error.response?.data?.message || "An error occurred",
        icon: "error",
      });
      setLoading(false);
    }
  };

  const handleChange = (property, value, selectedCompanyd) => {

    if (property === "email" || property === "secondaryEmail") {
      if (!validateEmail(value)) {
        setErrorKeys((prevKeys) => ({ ...prevKeys, [property]: true }));
      } else {
        setErrorKeys((prevKeys) => ({ ...prevKeys, [property]: false }));
      }
    }
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  const handleCancelModal = () => {
    setOpenModalView(false);
    setData({});
  };

  const AddModalData = () => {
    return (
      <>
        {loading && <Loader />}
        <SC.Form onSubmit={handleSubmit}>
          <SC.FormWrapper>
            <SC.LabelContainer>
              <SC.Label>
                Full Name <SC.Astrik>*</SC.Astrik>
              </SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <SC.Select
                    name="title"
                    value={data.title}
                    onChange={(e) => handleChange("title", e.target.value)}
                    style={{
                      height: "29px",
                      marginRight: "5px",
                      fontSize: "11px",
                    }}
                  >
                    {nameTitle.map((title) => (
                      <option key={title.id} value={title.id}>
                        {title.label}
                      </option>
                    ))}
                  </SC.Select>

                  <InputField
                    name="fullName"
                    value={data.fullName}
                    onChange={handleChange}
                    required
                    regexType={regexTypes.textOnly}
                    capitalize={true}
                    style={{ width: "72.5%", height: "29px" }}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>

            {/* Gender Radio Group */}
            {/* <Label label="Gender">
              <RadioGroup
                row
                name="gender"
                value={data?.gender}
                onChange={(e) => handleChange("gender", e.target.value)}
              >
                {genderOption.map((option) => (
                  <FormControlLabel
                    key={option.id}
                    value={option.id}
                    control={
                      <Radio
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: 16,
                          },
                          "&.Mui-checked": {
                            color: "#EC810B",
                          },
                          margin: "0px 0px 0px 10px",
                        }}
                      />
                    }
                    label={option.label}
                  />
                ))}
              </RadioGroup>
            </Label> */}

            {/* Email Inputs */}

            <SC.LabelContainer>
              <SC.Label>
                Email (Default) <SC.Astrik>*</SC.Astrik>
              </SC.Label>
              <SC.Children>
                <InputField
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                  required
                  disabled={isEditing}
                  type="email"
                  style={{ width: "92%", height: "29px" }}
                />

                {errorKeys.email && (
                  <SC.ValidtionMessages>
                    {validtionMessages.email}
                  </SC.ValidtionMessages>
                )}
              </SC.Children>
            </SC.LabelContainer>

            <Label label="Email (Secondary)">
              <InputField
                name="secondaryEmail"
                value={data.secondaryEmail}
                onChange={handleChange}
                type="email"
                style={{ width: "92%", height: "29px" }}
              />

              {errorKeys.secondaryEmail && (
                <SC.ValidtionMessages>
                  {validtionMessages.email}
                </SC.ValidtionMessages>
              )}
            </Label>

            {/* Cell Input */}

            <SC.LabelContainer>
              <SC.Label>
                Cell <SC.Astrik>*</SC.Astrik>
              </SC.Label>
              <SC.Children>
                <SC.Wrapper style={{ display: "flex", gap: "10px" }}>
                  <CountryCodeDropdown
                    name="cellCode"
                    defaultValue={data.cellCode}
                    onChange={handleChange}
                  />

                  <InputField
                    name="cell"
                    value={data.cell}
                    onChange={handleChange}
                    required
                    type="number"
                    style={{ width: "54.5%", height: "29px" }}
                    maxLength={15}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>

            <Label label="Tel (Secondary)">
              <SC.Wrapper style={{ gap: "10px" }}>
                <CountryCodeDropdown
                  name="telCode"
                  defaultValue={data.telCode}
                  onChange={handleChange}
                />

                <InputField
                  name="tel"
                  value={data.tel}
                  onChange={handleChange}
                  type="number"
                  style={{ width: "54.5%", height: "29px" }}
                  maxLength={15}
                />
              </SC.Wrapper>
            </Label>

            {/* Company Name */}
            <Label label="Company Name">
              <CompanyDropdown
                name="companyId"
                onChange={handleChange}
                defaultValue={data?.companyId || undefined}
                newItemLabel={"+ New Company"}
                setSelectedCompany={(value) => {
                  handleChange("companyId", value);
                }}
                disabledDropdown={companyId}
                width={"315px"}
              />
            </Label>

            {/* Username Input */}
            <SC.LabelContainer>
              <SC.Label>
                Username <SC.Astrik>*</SC.Astrik>
              </SC.Label>
              <SC.Children>
                <InputField
                  name="userName"
                  //value={data.userName}
                  value={data.email}
                  onChange={handleChange}
                  required
                  disabled={true}
                  style={{ width: "92%", height: "29px" }}
                />

                {errorKeys.userName && (
                  <SC.ValidtionMessages>
                    {validtionMessages.username}
                  </SC.ValidtionMessages>
                )}
              </SC.Children>
            </SC.LabelContainer>

            <SC.ButtonContainer>
              <Button
                caption="Cancel"
                onClick={handleCancelModal}
                fontSize="12px"
                style={{
                  marginBottom: 8,
                  background: theme.colors.cancelButton,
                  color: theme.colors.white,
                  minWidth: "100px",
                  borderRadius: "3px",
                  height: "30px",
                  fontSize: "12px",
                }}
              />
              <Button
                caption={isEditing ? "Save" : "Add"}
                type="submit"
                isLoading={loading}
                color="white"
                fontSize="12px"
                style={{
                  marginBottom: 8,
                  background: theme.gradient.themeGradient,
                  color: theme.colors.white,
                  minWidth: "100px",
                  height: "30px",
                  borderRadius: "3px",
                }}
              />
            </SC.ButtonContainer>
          </SC.FormWrapper>
        </SC.Form>
      </>
    );
  };

  return (
    <>
      {openModalView &&
        (isEditing ? (
          <BulkActionView
            title={`Edit User `}
            openModal={openModalView}
            renderBodyConditionally={AddModalData}
            handleCloseModal={() => {
              setOpenModalView(false);
              setIsEditing(false);
              setData("");
            }}
          />
        ) : (
          <BulkActionView
            title={"Create New User"}
            openModal={openModalView}
            renderBodyConditionally={AddModalData}
            handleCloseModal={() => {
              setOpenModalView(false);
              setData("");
            }}
          />
        ))}
    </>
  );
}

export default AddEditNewUser;
